import { Flex, styled } from '@grupoboticario/flora-react';

export const RefundStyles = {
  RefundWrapper: styled(Flex, {
    padding: '$4 $2',
    borderRadius: '$medium',
    border: '1px solid $alert-standard',
  }),
};
